
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Render from 'components/render';
import { IS_DEMO, IS_INDIAN_EXCHANGE } from 'constants/constants';
import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import {
  isUserIndianSelector,
  isUserPermissionForDepositDisabledSelector,
  userSelector,
} from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';
import IUser from 'types/IUser';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';

import styles from './accountHeaderPartials.module.scss';

// change order when rn webview
const DepositAccountHeaderCenter = ({ pathname }: { pathname: string }) => {
  const { t } = useTranslation(['account', 'common']);

  const isUserIndian = useAppSelector(isUserIndianSelector);
  const permissionDisabled = useAppSelector(isUserPermissionForDepositDisabledSelector);
  const user: IUser = useAppSelector(store => userSelector(store));
  const isCryptoDepositDisabled = user?.permissions?.crypto_deposit === 'disabled';

  const { BUY_CRYPTO_CLICKED, DEPOSIT_CLICKED_ALL_PAGES } = MIXPANEL_EVENT_NAMES.DEPOSITS;

  return (
    <Box className={cx('header-text', 'deposit-tabs')}>
      <Render when={!isCryptoDepositDisabled}>
        <DeltaButton
          useBasicButton
          data-testid="deposit-tab-mobile"
          as={Link}
          to={routes.account.deposit}
          replace
          onClick={() => {
            trackMixpanelEvent(DEPOSIT_CLICKED_ALL_PAGES, {
              source: 'Deposit Page',
            });
          }}
          className={cx(
            'tab',
            'deposit',
            {
              active: pathname.includes('/deposit'),
            },
            styles.order2
          )}
        >
          {t('account:depositCrypto')}{' '}
        </DeltaButton>
      </Render>

      <Render
        when={!IS_DEMO&& !IS_INDIAN_EXCHANGE && !permissionDisabled && !isUserIndian}
      >
        <DeltaButton
          useBasicButton
          data-testid="buy-crypto-tab-mobile"
          as={Link}
          to={routes.account.buy_crypto}
          replace
          onClick={() => {
            trackMixpanelEvent(BUY_CRYPTO_CLICKED, {
              source: 'Deposit Page',
            });
          }}
          className={cx('tab', 'buyCrypto', styles.order2, {
            active: pathname.includes('/buy_crypto'),
          })}
        >
          {t('account:buyCrypto')}
        </DeltaButton>
      </Render>
    </Box>
  );
};

export default DepositAccountHeaderCenter;
